/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BathroomsInputs */

const en_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathrooms`)
};

const es_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baños`)
};

const fr_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salles de bain`)
};

const de_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badezimmer`)
};

const ja_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バスルーム数`)
};

const zh_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浴室`)
};

const ar_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دورات المياه`)
};

const id_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamar Mandi`)
};

const it_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagni`)
};

const ru_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ванные комнаты`)
};

const pt_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banheiros`)
};

const ko_bathrooms = /** @type {(inputs: BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`욕실 수`)
};

/**
* | output |
* | --- |
* | "Bathrooms" |
*
* @param {BathroomsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bathrooms = /** @type {((inputs?: BathroomsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BathroomsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bathrooms(inputs)
	if (locale === "es") return es_bathrooms(inputs)
	if (locale === "fr") return fr_bathrooms(inputs)
	if (locale === "de") return de_bathrooms(inputs)
	if (locale === "ja") return ja_bathrooms(inputs)
	if (locale === "zh") return zh_bathrooms(inputs)
	if (locale === "ar") return ar_bathrooms(inputs)
	if (locale === "id") return id_bathrooms(inputs)
	if (locale === "it") return it_bathrooms(inputs)
	if (locale === "ru") return ru_bathrooms(inputs)
	if (locale === "pt") return pt_bathrooms(inputs)
	return ko_bathrooms(inputs)
});